import BasicInput from '@shared/ui/forms/inputs/BasicInput';
import { userNameRule } from '@utils/validation';
import { useTranslation } from 'react-i18next';

export default function MemberNameInput({ control, errors }) {
  const { t } = useTranslation();
  return (
    <BasicInput
      control={control}
      name="name"
      label={t('name')}
      validation={userNameRule}
      error={errors.name}
      placeholder={t('name_placeholder')}
      counter={25}
    />
  );
}
